import { graphql } from 'gatsby';

export const linkableFragment = graphql`
  fragment linkable on PRISMIC__Linkable {
    _linkType
    __typename

    ...page
    ...article
    ...project
    ...association

    ... on PRISMIC__ExternalLink {
      url
    }
    ... on PRISMIC__FileLink {
      url
    }
    ... on PRISMIC__Document {
      _meta {
        ...meta
      }
    }
    ... on PRISMIC__ImageLink {
      url
    }
  }
`;
